import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SecondaryAdvisorService {
  constructor(private http: HttpClient) {}

  public assignSecondaryAdvisor(clientId: string, advisorId: string, specialization?: string): Observable<void> {
    let params: HttpParams = new HttpParams();

    if (specialization) {
      params = params.set('specialization', specialization);
    }

    return this.http.put<void>(`${environment.apiEndpoint}/account/client/${clientId}/secondary-advisor/${advisorId}`, {
      params,
    });
  }

  public updateSecondaryAdvisor(clientId: string, advisorId: string, specialization?: string): Observable<void> {
    let params: HttpParams = new HttpParams();

    if (specialization) {
      params = params.set('specialization', specialization);
    }

    return this.http.put<void>(
      `${environment.apiEndpoint}/account/client/${clientId}/secondary-advisor/${advisorId}/specialization`,
      {
        params,
      },
    );
  }

  public unassignSecondaryAdvisor(clientId: string, advisorId: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiEndpoint}/account/client/${clientId}/secondary-advisor/${advisorId}`,
    );
  }
}
